import { RefreshCw } from 'lucide-react';
import { Button } from 'twyne-new.ui';

import { useGrid } from '@/components/Grid/context';

export default function RefreshButton() {
  const { store: { loading }, handleRefresh } = useGrid()

  return <Button color='success' variant='outline' size='lg' onClick={handleRefresh} disabled={loading}>
    <div className="relative flex items-center justify-center">
      <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
    </div>
  </Button>
}
